<template>
  <section class="admin-content" id="contact-search">
    <Navbar />

    <main class="admin-main">
      <section class="container">
        <div class="">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card table-card shadow m-b-30" style="margin-top: 35px">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-user-plus" style="font-size:13px;"></i></div>
                  <div>
                    <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Add Enrollee Form</p>
                    <small style="color:rgba(255,255,255,.7);">Fields marked with <span class="text-danger">*</span> are compulsory</small>
                  </div>
                </div>
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <div class="form-row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="inputCity"
                            >Select Sector
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            required
                            v-model="sector"
                            disabled
                          >
                            <option value="formal">Formal Sector</option>
                            <option value="informal">Informal Sector</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="inputCity"
                            >Select Plan Type
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            required
                            v-model="register.plan_type"
                          >
                            <option value="Family">Family</option>
                            <option value="Individual">Individual</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-12" v-if="sector == 'informal'">
                        <div class="form-group">
                          <label for="inputCity"
                            >Select Informal Sector
                            <span class="text-danger">*</span></label
                          >
                          <select
                            class="form-control"
                            required
                            v-model="register.sector"
                          >
                            <option value="Basic Healthcare Provision Fund">
                              Basic Healthcare Provision Fund
                            </option>
                            <option value="Vulnerable Groups">
                              Vulnerable Groups
                            </option>
                            <option value="Voluntary Contributor">
                              Voluntary Contributor
                            </option>
                            <option value="Organized Community Healthcare Plan">
                              Organized Community Healthcare Plan
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-6" v-if="sector == 'formal'">
                        <div class="form-group">
                          <label for="inputCity"
                            >Select Category<span class="text-danger"
                              >*</span
                            ></label
                          >
                          <select
                            class="form-control"
                            required
                            v-model="register.sector"
                          >
                            <option value="State Civil Servant">
                              State Civil Servant
                            </option>
                            <option value="LGA Civil Servant">
                              LGA Civil Servant
                            </option>

                            <option value="Organized Private Sector">
                              Organized Private Sector
                            </option>

                            <!-- <option
                              value="Tertiary Student Health Insurance Plan (T-SHIP)"
                            >
                              Tertiary Student Health Insurance Plan (T-SHIP)
                            </option> -->
                          </select>
                        </div>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Select MDA </label>
                        <v-select
                          v-model="register.place_of_work"
                          :options="mdas"
                          label="name"
                        ></v-select>
                      </div>

                      <div
                        class="form-group col-md-6"
                        v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <label for="inputEmail4">Institution Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.place_of_work"
                          placeholder="example; University of Ife"
                        />
                      </div>
                      <div
                        class="form-group col-md-6"
                        v-if="
                          register.sector == 'Organized Private Sector Plan'
                        "
                      >
                        <label for="inputEmail4">Organization Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.place_of_work"
                          placeholder="example;  Name of Company"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4"
                          >NIN Number <span class="text-danger">*</span></label
                        >
                        <input
                          required
                          type="text"
                          inputmode="numeric"
                          pattern="\d{11}"
                          maxlength="11"
                          class="form-control"
                          v-model="register.nimc_number"
                          @input="register.nimc_number = register.nimc_number.replace(/\D/g, '').slice(0, 11)"
                          placeholder="NIN Number"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputPassword4"
                          >Surname <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          required
                          v-model="register.lastname"
                          placeholder="Last Name"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputEmail4"
                          >First Name <span class="text-danger">*</span></label
                        >
                        <input
                          type="text"
                          class="form-control"
                          required
                          v-model="register.firstname"
                          placeholder="First Name"
                        />
                      </div>

                      <div class="form-group col-md-4">
                        <label for="inputPassword4">Middle Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.middlename"
                          placeholder="Middle Name"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <p>
                          <label for="inputPassword4">Date of Birth: </label>
                        </p>
                        <input
                          type="date"
                          required
                          class="form-control"
                          v-model="register.dob"
                        />
                      </div>

                      <div
                        class="form-group col-md-4"
                        v-if="
                          register.sector !=
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <p>
                          <label for="inputPassword4"
                            >Date of First Appointment:
                          </label>
                        </p>
                        <input
                          type="date"
                          class="form-control"
                          v-model="register.date_of_entry"
                        />
                      </div>

                      <div
                        class="form-group col-md-4"
                        v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <p>
                          <label for="inputPassword4"
                            >Year of Admission:
                          </label>
                        </p>
                        <input
                          type="date"
                          required
                          class="form-control"
                          v-model="register.date_of_entry"
                        />
                      </div>

                      <div
                        class="form-group col-md-4"
                        v-if="
                          register.sector !=
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <p>
                          <label for="inputPassword4">Retirement Date: </label>
                        </p>
                        <input
                          type="date"
                          class="form-control"
                          v-model="register.expiry_date"
                        />
                      </div>
                      <div
                        class="form-group col-md-4"
                        v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <p>
                          <label for="inputPassword4"
                            >Year of Graduation:
                          </label>
                        </p>
                        <input
                          type="date"
                          required
                          class="form-control"
                          v-model="register.expiry_date"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputEmail4">Email</label>
                        <input
                          type="email"
                          class="form-control"
                          v-model="register.email"
                          placeholder="Email"
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputPassword4"
                          >Phone Number
                          <span class="text-danger">*</span></label
                        >
                        <input v-phone
                          type="text"
                          class="form-control"
                          v-model="register.phone_number"
                          placeholder="Phone Number"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputCity"
                          >Gender <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="register.gender"
                        >
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                        </select>
                      </div>

                      <div
                        class="form-group col-md-6"
                        v-if="
                          register.sector !=
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <label for="inputEmail4">Salary Number/Staff ID</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.salary_number"
                          placeholder="Staff ID"
                        />
                      </div>
                      <div
                        class="form-group col-md-6"
                        v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <label for="inputEmail4">Matriculation Number</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.salary_number"
                          placeholder="Matric. Number"
                          required
                        />
                      </div>

                      <div
                        class="form-group col-md-6"
                        v-if="
                          register.sector !=
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <label for="inputEmail4">Grade Level/Step</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.grade_level"
                          placeholder="Grade Level/Step"
                        />
                      </div>

                      <div
                        class="form-group col-md-6"
                        v-if="
                          register.sector ==
                          'Tertiary Student Health Insurance Plan (T-SHIP)'
                        "
                      >
                        <label for="inputEmail4">Class Year</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.grade_level"
                          placeholder="200L"
                          required
                        />
                      </div>

                      <div class="form-group col-md-6">
                        <label
                          >Marital Status
                          <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="register.marital_status"
                        >
                          <option value="Married">Married</option>
                          <option value="Widow">Widow</option>
                          <option value="Single">Single</option>
                          <option value="Separated">Separated</option>
                          <option value="Divorced">Divorced</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity"
                          >LGA <span class="text-danger">*</span></label
                        >
                        <select
                          class="form-control"
                          required
                          v-model="register.localgovt"
                          @change="fetchWards($event)"
                        >
                          <option
                            v-for="lga in lga_states"
                            v-bind:key="lga"
                            :value="lga.id"
                          >
                            {{ lga.local_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label>Ward </label>
                        <select class="form-control" v-model="register.ward">
                          <option
                            v-for="ward in wards"
                            v-bind:key="ward.id"
                            :value="ward.id"
                          >
                            {{ ward.ward_name }}
                          </option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label
                          >Principal Facility for Accessing Health Care
                        </label>
                        <v-select
                          v-model="register.provider_id"
                          :options="providers"
                          label="agency_name"
                          :value="register.provider_id"
                          @input="selected"
                        ></v-select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputCity">Blood Group</label>
                        <select class="form-control" v-model="register.blood">
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>

                      <div class="form-group col-md-6">
                        <label for="inputAddress">Home Address</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="register.address"
                          placeholder="1234 Main St"
                        />
                      </div>

                      <div class="form-group col-md-12">
                        <label>Photo</label>
                        <div class="d-flex align-items-center flex-wrap" style="gap: 10px;">
                          <button class="btn btn-outline-info" type="button" @click="takePicAndroid">
                            <i class="fe fe-camera mr-1"></i> Capture Photo
                          </button>
                          <div class="fileinput fileinput-new" data-provides="fileinput">
                            <span class="btn btn-file">
                              <span class="fileinput-new"><i class="fe fe-upload mr-1"></i> Upload Photo</span>
                              <span class="fileinput-exists">Change</span>
                              <input type="file" name="..." multiple v-on:change="attachPic" />
                            </span>
                            <span class="fileinput-filename"></span>
                            <a href="#" class="close fileinput-exists" data-dismiss="fileinput"
                              style="float: none">&times;</a>
                          </div>
                        </div>
                        <div v-if="register.user_image" class="mt-3">
                          <img :src="register.user_image" class="rounded" alt="User Photo"
                            style="width: 130px; height: 150px; object-fit: cover; border: 2px solid #dee2e6;"
                            onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'" />
                          <div class="mt-2" v-if="register.user_image && photoOriginal">
                            <button class="btn btn-outline-secondary btn-sm" type="button" @click="cropPhoto(photoOriginal)">
                              <i class="fe fe-crop mr-1"></i> Adjust
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <p class="mb-2">
                        <strong>
                          Declaration & warranty on behalf of all persons
                          proposed to be insured</strong
                        >
                      </p>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I/We hereby declare, on my behalf and on behalf of
                            all persons proposed to be insured that the above
                            statements, answers and/or particulars given by me
                            are true and complete in all respects to the best of
                            my knowledge and that I/We am/ are authorized to
                            propose on behalf of these other persons.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I understand that the information provided by me
                            will form the basis of insurance policy, is subject
                            to the Board approved underwriting policy of RIVCHPP
                            and that the policy will come into force only after
                            full receipt of the premium chargeable.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I/ We further declare that I/We will notify in
                            writing any change occurring in the occupation or
                            general health of the life to be insured/ proposer
                            after the proposal has been submitted but before
                            communication of the risk acceptance by RIVCHPP.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I/We declare and consent to RIVCHPP seeking medical
                            information from any hospital who at any time has
                            attended on the life to be insured/ proposer or from
                            any past or present employer concerning anything
                            which affects the physical and mental health of the
                            life to be assured/proposer and seeking information
                            from any insurance company to which an application
                            for insurance on the life to be assured/ proposer
                            has been made for the purpose of underwriting the
                            proposal and/or claim settlement.
                          </label>
                        </div>
                      </div>

                      <div class="form-group">
                        <div class="form-check">
                          <input
                            required
                            class="form-check-input"
                            type="checkbox"
                            id="checkbox1"
                          />
                          <label class="form-check-label" for="checkbox1">
                            I/ We authorize RIVCHPP to share information
                            pertaining to my proposal including the medical
                            records for the sole purpose of proposal
                            underwriting and/or claims settlement and with any
                            Governmental and/or Regulatory Authority.
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-success btn-block btn-lg">
                        Submit <i class="fe fe-send"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading
                :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"
              ></loading>
            </div>
          </div>
        </div>
      </section>
      <PhotoCropper ref="photoCropper" />
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
import PhotoCropper from "@/components/PhotoCropper.vue";

export default {
  components: { PhotoCropper,
    Navbar,
    Loading,
  },
  data() {
    return {
      photoOriginal: "",
      isLoading: false,
      fullPage: true,
      states: "",
      show: false,
      clients: "",
      providers: "",
      sector: "formal",
      mdas: "",
      wards: "",
      tpas: "",
      providers_wards: "",
      state: "",
      OfficerDetails: "",
      current_page: "",
      selected_provider: "",
      selected_provider_dependents: "",
      lga_states: "",
      response: "",
      register: {
        firstname: "",
        lastname: "",
        middlename: "",
        nimc_number: "",
        plan_type: "",
        email: "",
        phone_number: "",
        type: "client",
        agency_id: "",
        state: "",
        localgovt: "",
        ward: "",
        address: "",
        blood: "",
        gender: "",
        genotype: "",
        dob: "",
        expiry_date: "",
        salary_number: "",
        provider_id: "",
        point_of_care: "",
        sector: "",
        finger_print: "",
        place_of_work: "",
        org_id: "",
        grade_level: "",
        date_of_entry: "",
        marital_status: "",
        category_of_vulnerable_group: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    //
  },

  methods: {
    attachPic(event) {
      const file = event.target.files[0];
      event.target.value = "";
      if (!file) return;
      const reader = new FileReader();
      reader.onload = (e) => this.cropPhoto(e.target.result);
      reader.readAsDataURL(file);
    },
    // Opens the cropper; keeps the uncropped photo so it can be adjusted again.
    async cropPhoto(src) {
      const cropped = await this.$refs.photoCropper.open(src);
      if (!cropped) return false;
      this.photoOriginal = src;
      this.register.user_image = cropped;
      return true;
    },
    async takePicAndroid() {
      try {
        const image = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: CameraSource.Camera,
        });

        if (!(await this.cropPhoto("data:image/jpeg;base64," + image.base64String))) return;
        this.$toasted.info("Image taken Successfully!", {
          position: "top-center",
          duration: 8000,
        });
      } catch (err) {
        if (err && err.message !== "User cancelled photos app") {
          this.$toasted.error("Could not access camera.", {
            position: "top-center",
            duration: 3000,
          });
        }
      }
    },
    selected(value) {
      this.selected_provider = value.id;
    },
    selectedPointocare(value) {
      this.selected_provider_dependents = value.agency_name;
    },
    submitForm() {
      if (this.user.type == "employee") {
        if (this.register.provider_id != "") {
          this.registerUserEmployee();
        } else {
          this.$toasted.error(`Facility cannot be null`, {
            position: "top-center",
            duration: 3000,
          });
        }
      }

      if (this.user.type == "shis") {
        if (this.register.provider_id != "") {
          this.registerUserAdmin();
        } else {
          this.$toasted.error(`Facility cannot be null`, {
            position: "top-center",
            duration: 3000,
          });
        }
      }
    },
    fetchWards() {
      this.axios
        .get(`/api/v1/auth/getwards/${event.target.value}`)
        .then((response) => {
          this.wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    fetchLga() {
      this.axios
        .get(`/api/v1/auth/lga/2679`)
        .then((response) => {
          this.lga_states = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getMDAs() {
      this.axios
        .get(`/api/v1/auth/ministries/407465`)
        .then((response) => {
          this.mdas = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    registerUserAdmin() {
      // console.log(this.selected_provider ? this.selected_provider : this.register.provider_id);
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/registerProvider", {
          nimc_number: this.register.nimc_number,
          firstname: this.register.firstname.toUpperCase(),
          lastname: this.register.lastname.toUpperCase(),
          middlename: this.register.middlename.toUpperCase(),
          email: this.register.email,
          phone_number: this.register.phone_number,
          plan_type: this.register.plan_type,
          type: this.register.type,
          sectorType: this.sector,
          agency_id: 407465,
          provider_id: this.selected_provider
            ? this.selected_provider
            : this.register.provider_id,
          state: "2679",
          role: 0,
          password: "euhler",
          org_id: this.register.org_id,
          localgovt: this.register.localgovt,
          ward: this.register.ward,
          blood: this.register.blood,
          dob: this.register.dob,
          expiry_date: this.register.expiry_date,
          address1: this.register.address,
          genotype: this.register.genotype,
          gender: this.register.gender,
          sector: this.register.sector,
          place_of_work: this.register.place_of_work.name,
          point_of_care: this.register.provider_id.id,
          finger_print: this.register.finger_print,
          salary_number: this.register.salary_number,
          grade_level: this.register.grade_level,
          date_of_entry: this.register.date_of_entry,
          marital_status: this.register.marital_status,
          category_of_vulnerable_group:
            this.register.category_of_vulnerable_group,
          enrolled_by: this.user.id,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$toasted.info("Client added Successfully", {
            position: "top-center",
            duration: 3000,
          });
          let user_id = response.data.data.id;

          this.$router.push(`/client/${user_id}`);
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.response = error.response.data.errors;
          if (this.response.firstname != null) {
            this.$toasted.error(`${this.response.firstname}`, {
              position: "top-center",
              duration: 3000,
            });
          }
          if (this.response.lastname != null) {
            this.$toasted.error(`${this.response.lastname}`, {
              position: "top-center",
              duration: 3000,
            });
          }
          if (this.response.phone_number != null) {
            this.$toasted.error(`${this.response.phone_number}`, {
              position: "top-center",
              duration: 3000,
            });
          }
        });
    },

    registerUserEmployee() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/registerProvider", {
          agency_id: this.user.institutional_id,
          nimc_number: this.register.nimc_number,
          firstname: this.register.firstname.toUpperCase(),
          lastname: this.register.lastname.toUpperCase(),
          middlename: this.register.middlename.toUpperCase(),
          email: this.register.email,
          phone_number: this.register.phone_number,
          plan_type: this.register.plan_type,
          type: this.register.type,
          sectorType: this.sector,
          provider_id: this.register.provider_id.id,
          state: "2679",
          role: 0,
          password: "euhler",
          org_id: this.register.org_id,
          localgovt: this.register.localgovt,
          ward: this.register.ward,
          blood: this.register.blood,
          address1: this.register.address,
          genotype: this.register.genotype,
          dob: this.register.dob,
          expiry_date: this.register.expiry_date,
          date_of_entry: this.register.date_of_entry,
          gender: this.register.gender,
          sector: this.register.sector,
          place_of_work: this.register.place_of_work.name,
          point_of_care: this.register.provider_id.id,
          // finger_print: this.register.finger_print,
          salary_number: this.register.salary_number,
          grade_level: this.register.grade_level,
          marital_status: this.register.marital_status,
          // category_of_vulnerable_group: this.register.category_of_vulnerable_group,
          enrolled_by: this.user.id,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          // this.getClients();
          this.$toasted.info("Client added Successfully", {
            position: "top-center",
            duration: 3000,
          });
          let user_id = response.data.data.id;
          this.$router.push(`/client/${user_id}`);
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.response = error.response.data.errors;
          this.$toasted.error(`${JSON.stringify(this.response)}`, {
            position: "top-center",
            duration: 3000,
          });
        });
    },
    getProviders() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/providerAgency/407465`, {
          params: {
            status: 1,
          },
        })
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    getProvidersByWards() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(
          `/api/v1/auth/providerAgencies/407465/${this.register.localgovt}/${this.register.ward}`
        )
        .then((response) => {
          this.providers_wards = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.fetchLga();
    this.getMDAs();
    this.getProviders();
  },
};
</script>
